// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    activity: 'Actividad',
    add_check_list_item_placeholder: 'Agregar elemento de lista de verificación o use Ctrl+V para pegar una lista de elementos',
    add_checklist_label: 'Agregar lista de verificación',
    add_more: 'Agregar más',
    add_reaction_title: 'Agregar reacción',
    ai: 'IA',
    ai_analyzing: 'Analizando patrones',
    ai_building: 'Construyendo modelo de pronóstico',
    ai_description: 'El pronóstico de IA de {brandName} utiliza algoritmos de aprendizaje automático para encontrar patrones y relaciones entre eventos y acciones procesando los datos históricos de su cuenta. Como resultado, mostrará la fecha de finalización del proyecto más probable y su nivel de confianza en esta predicción.',
    ai_forecast: 'Pronóstico de IA',
    ai_forecast_date: 'Fecha de finalización del proyecto pronosticada por IA',
    ai_how_works: 'Más información sobre cómo funciona la IA',
    ai_not_enough_data: 'No hay suficientes datos históricos para realizar un pronóstico confiable. Usar el sistema activamente garantizará pronósticos más precisos. <a href={0} target=\'_blank\' class={1}>Más información</a> sobre el pronóstico de IA.',
    ai_planned_date: 'Fecha de finalización del proyecto planificada',
    ai_result: 'Resultados del pronóstico de IA',
    ai_reviewing: 'Revisando datos históricos',
    apply: 'Aplicar',
    available: 'Disponible',
    back: 'Atrás',
    CanChangeWorkflowForProjectOutdatedData: 'El flujo de trabajo ya está aplicado al proyecto. Por favor, actualice la página para actualizar los datos.',
    CanDeleteCategoryHasTask: 'No es posible eliminar la categoría que se utiliza en actividades.',
    CanDeletePriorityHasProject: 'No es posible eliminar la prioridad que se utiliza en proyectos.',
    CanDeletePriorityHasTask: 'No es posible eliminar la prioridad que se utiliza en actividades.',
    CanDeletePriorityIsInternal: 'No es posible eliminar la prioridad interna del sistema.',
    CanDeleteStatusIsWorkflowTypeStatus: 'No es posible eliminar el estatus predeterminado.',
    CanDeleteStatusUsed: 'No es posible eliminar el estatus que se utiliza en alguna entidad.',
    CanDeleteThresholdIsInternal: 'No es posible eliminar el umbral interno del sistema.',
    CanDeleteVacationTypeDefault: 'No es posible eliminar el tipo de vacaciones predeterminado.',
    CanDeleteVacationTypeHasVacation: 'No es posible eliminar el tipo de vacaciones que tiene vacaciones asignadas.',
    CanDeleteWorkflowIsSingle: 'Debe haber al menos un flujo de trabajo en el sistema.',
    CanDeleteWorkflowIsUsed: 'No es posible eliminar el flujo de trabajo que se utiliza en proyectos.',
    CanDisableStatusIsUsed: 'No es posible deshabilitar el estatus que se utiliza en una entidad',
    CanDisableStatusIsWorkflowTypeStatus: 'No es posible deshabilitar el estatus predeterminado',
    CanEdit_Task_AccessDenied: 'No tiene permisos para editar esta actividad',
    CanEditValueThresholdIsInternal: 'Los valores preestablecidos de umbral del sistema no se pueden modificar.',
    CanSetWorkflowTypeStatusIsWorkflowTypeStatus: 'No es posible marcar el estatus como predeterminado si ya lo es.',
    change: 'cambiar',
    ChangeProjectProgressError: 'El progreso de un proyecto con tareas no puede ser editado.',
    ChangeTaskProgressError: 'El progreso de una tarea principal no puede ser editado.',
    check_all_label: 'Seleccionar todo',
    checklist_name: 'Lista de verificación',
    column_group_custom_fields: 'Campos personalizados',
    column_group_custom_fields_user: 'Campos personalizados de usuario',
    columns: 'Columnas',
    Completed_Projects: 'Proyectos completados',
    Completed_Tasks: 'Actividades completadas',
    Copy_Text: 'Copiar',
    copyPostfix: 'Copiar',
    create: 'Crear',
    created_by: 'Creado por',
    creation_date: 'Fecha de creación',
    current_plan: 'Plan actual: <b>{0}</b>',
    dates: 'Fechas',
    delete_checklist_label: 'Eliminar lista de verificación',
    description_title: 'Descripción',
    edit_check_list_item_placeholder: 'Editar elemento de la lista de verificación',
    Edit_Text: 'Editar',
    emoji: 'Emoji',
    empty_list: 'No se encontraron resultados que coincidan con la consulta/filtro aplicado',
    error_reload: 'La versión de {brandName} se ha actualizado. Para el correcto funcionamiento de la aplicación, debe recargar la página.',
    export: 'Exportar',
    export_csv: 'Exportar a CSV',
    export_pdf: 'Exportar a PDF',
    filters: 'Filtros',
    freeze: 'Congelar columna',
    from: 'Desde',
    general: 'General',
    global_search: 'Buscar',
    global_search_text: 'Buscar mensajes, archivos y más',
    GotIt: 'Entendido',
    group_by: 'Agrupar por',
    group_by_template: 'Agrupar por: {0}',
    here: 'aquí',
    hourly_rate_unit: '/hr',
    icons: 'Íconos',
    in: 'en',
    in_use: 'En uso',
    items_text: '1#{0} elemento#{0} elementos',
    job_role: 'Puesto de trabajo',
    label_custom_date_range: 'Rango de fechas personalizado',
    label_daily: 'Diario',
    label_monthly: 'Mensual',
    label_weekly: 'Semanal',
    label_yearly: 'Anual',
    least_likely: 'Menos probable',
    month: 'Mes',
    MoreActions: 'Más acciones',
    most_likely: 'Más probable',
    move_down: 'Mover hacia abajo',
    move_up: 'Mover hacia arriba',
    name_title: 'Nombre',
    next_month: 'Próximo mes',
    next_week: 'Próxima semana',
    no: 'No',
    no_available_filters: 'No hay valores disponibles para el filtro',
    no_data_to_display: 'No hay datos para mostrar',
    no_data_to_display_for_widget: 'No hay datos para mostrar. Los filtros, incluidos tanto los específicos del widget como los generales, pueden estar impidiendo la visualización de datos.',
    NoPermissionToArchiveProject: 'La acción solicitada (archivar proyecto) no está disponible por la siguiente razón: No tiene permisos para archivar el proyecto.',
    not_calculated: 'No calculado',
    not_in_use: 'No en uso',
    pause: 'Pausa',
    PortfolioLimitError: 'Ha alcanzado el límite de 60 portafolios en la Edición Team. Por favor, actualice a {brandName} Edición Enterprise.',
    previous_month: 'Mes anterior',
    previous_week: 'Semana anterior',
    previous_year: 'Año anterior',
    qb_disconnect_denied: 'No tienes un token de QuickBooks asociado con esta cuenta',
    quarter: 'Trimestre',
    quick_search_placeholder: 'Buscar por ID o nombre',
    quick_search_placeholder_for_archive: 'Buscar proyectos archivados por nombre o ID',
    RateLimitExceededByAccount: 'Pedimos disculpas por las molestias, pero debido al alto tráfico actualmente estamos limitando la cantidad de solicitudes que puedes realizar. Por favor, intenta de nuevo más tarde.',
    RateLimitExceededByUser: 'Pedimos disculpas por las molestias, pero debido al alto tráfico actualmente estamos limitando la cantidad de solicitudes que puedes realizar. Por favor, intenta de nuevo más tarde.',
    read_more: 'Aprende más',
    RecordConversionToActivityDifferentWorkflows: 'No es posible convertir el registro, ya que se han aplicado diferentes flujos de trabajo al proyecto y la plantilla.',
    records: 'Registros',
    remove_checklist_item_label: 'Eliminar elemento de la lista de verificación',
    request_resources: 'Solicitar recursos',
    reset_timer_title: 'Restablecer temporizador',
    resource_type_label: 'Tipo de recurso',
    resume: 'Reanudar',
    role: 'Rol',
    schedule_hours: 'Horas programadas',
    security_group: 'Nivel de acceso',
    select: 'Seleccionar',
    share: 'Compartir',
    short_quarter0: 'T1',
    short_quarter1: 'T2',
    short_quarter2: 'T3',
    short_quarter3: 'T4',
    show: 'Mostrar',
    show_template: 'Mostrar: {0}',
    skillsDeleteConfirm: 'La habilidad se eliminará de los perfiles de otros usuarios y roles de trabajo donde se esté utilizando',
    SnapshotsLimitError: 'Has alcanzado el límite de 3 instantáneas de proyectos. Por favor, actualiza a {brandName} Edición Enterprise.',
    sort: 'Ordenar',
    sort_activities: 'Ordenar actividades por:',
    sort_ascending: 'Ordenar ascendente',
    sort_az: 'Ordenar A→Z',
    sort_descending: 'Ordenar descendente',
    sort_projects: 'Ordenar proyectos por:',
    sort_resources: 'Ordenar recursos por:',
    sort_za: 'Ordenar Z→A',
    start: 'Iniciar',
    start_analyze: 'Iniciar análisis',
    start_new_project: 'Iniciar nuevo proyecto',
    stop_timer_title: 'Detener temporizador',
    sub_features_list_title: 'Esta función incluye:',
    SystemTaskCreatorName: 'Sistema',
    Task_CanAccessBillingInformation_AccessDenied: 'No tienes permisos para editar la configuración de facturación de esta actividad',
    this_month: 'Este mes',
    this_week: 'Esta semana',
    this_year: 'Este año',
    ThresholdValueDuplicate: 'Este valor de umbral ya ha sido agregado.',
    TimeoutErrorMessage: 'Tu solicitud ha excedido el tiempo de espera. Por favor, intenta de nuevo más tarde.',
    to: 'A',
    today: 'Hoy',
    uncheck_all_label: 'Desmarcar todo',
    unfreeze: 'Descongelar columna',
    UnknownErrorMessage: 'Lo sentimos, algo salió mal... Por favor, actualiza la página.',
    update_date: 'Fecha de actualización',
    updated_by: 'Actualizado por',
    upgrade: 'Actualizar',
    upgrade_to_enterprise: 'Actualizar a Enterprise',
    usage: 'Uso',
    week: 'Semana',
    WindowUnload_UnsavedChanges: 'Hay cambios sin guardar. ¿Estás seguro de que deseas salir de esta página?',
    year: 'Año',
    yes: 'Sí',
    yesterday: 'Ayer',
};
